import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import PlayIcon from 'react-icons/lib/fa/play'
import APIRequest from '../../helpers/APIRequest'
import StructureDescription from './structureDescription'
import {Progress} from 'reactstrap'

import {getFormula} from '../../helpers/lib'
// import SuccessIcon from 'react-icons/lib/md/check'
// import CloseIcon from 'react-icons/lib/md/close'
// import EditIcon from 'react-icons/lib/md/edit'
// import DeleteIcon from 'react-icons/lib/md/delete'
// import FailedIcon from 'react-icons/lib/md/sms-failed'
// import TimeIcon from 'react-icons/lib/md/access-time'
// import MinimizeIcon from 'react-icons/lib/fa/angle-down'
// import SettingsIcon from 'react-icons/lib/md/settings'
import moment from 'moment'



import {
  //   Badge,

  // Collapse,
  Row,
  Col,
  //   Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // CardActions,
  // CardTitle,
  Button
  //   ButtonToolbar,
  //   ButtonGroup,
  //   ButtonDropdown,
  //   Label,
  //   Input,
  //   Table
} from "reactstrap";

class StructureItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      dropdownOptions: false,
      modalRemoveFromProject: false,
      modalTutorialOrdered: false,
      isRelaxating: false,
      isTryaAgaining: false
    }
    this.toggle = this.toggle.bind(this);
    this.toggleOptions = this.toggleOptions.bind(this);
    this.toggleRemoveFromProject = this.toggleRemoveFromProject.bind(this);
    this.removeStructure = this.removeStructure.bind(this);
    this.toggleTutorialOdered = this.toggleTutorialOdered.bind(this);
    this.tryAgain = this.tryAgain.bind(this);
    this.getRelaxedStructure = this.getRelaxedStructure.bind(this);

  }

  toggle() {
    this.setState({
      opened: !this.state.opened
    })
  }

  toggleOptions() {
    this.setState({
      dropdownOptions: !this.state.dropdownOptions
    })
  }

  toggleRemoveFromProject() {
    this.setState({
      modalRemoveFromProject: !this.state.modalRemoveFromProject
    })
  }

  toggleTutorialOdered() {
    this.setState({
      modalTutorialOrdered: !this.state.modalTutorialOrdered
    })
  }

  removeStructure() {
    const projectId = this.props.project._id;
    APIRequest.post(`projects/${projectId}/removeStructure`, {
      id: this.props.structure._id
    }).then(res => {
      this.props.receiveProject(res.data);
      this.toggleRemoveFromProject();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  tryAgain(e) {
    e.preventDefault();
    if (this.state.isTryaAgaining) {
      return false;
    }
    this.setState({
      isTryaAgaining: true
    })
    APIRequest.get(`structures/${this.props.structure._id}/tryAgain`).then(res => {

      this.setState({
        isTryaAgaining: false
      })
      console.log('getRelaxedStructure', res);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);

      this.setState({
        isTryaAgaining: false
      })
    }).then(() => this.props.getProjectById(this.props.project._id));
  }

  getRelaxedStructure(e) {
    e.preventDefault();
    if (this.state.isRelaxating) {
      return false;
    }
    this.setState({
      isRelaxating: true
    });
    APIRequest.get(`structures/${this.props.structure._id}/relaxedStructure`).then(res => {
      console.log('getRelaxedStructure', res);
      this.setState({
        isRelaxating: false
      });

    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
      this.setState({
        isTryaAgaining: false
      });
    }).then(() => this.props.getProjectById(this.props.project._id));
  }

  render() {
    const { props } = this;
    const {
      structure = {},
      project = {}
    } = props;


    return (
        <Card className={`h-100 m-0 structure card-accent-${ !structure.isOrdered
        ? 'warning'
        : !structure.relaxedStructure && structure.relaxationStatus === 'off'
          ? 'info'
          : ''}${ !structure.relaxedStructure && structure.relaxationStatus === 'initialised'
            ? 'seconday'
            : ''}${ !structure.relaxedStructure && structure.relaxationStatus === 'pending'
              ? 'warning'
              : ''}${ !structure.relaxedStructure && structure.relaxationStatus === 'running'
                ? 'info'
                : ''}${ !structure.relaxedStructure && structure.relaxationStatus === 'failed'
                  ? 'danger'
                  : ''}${ structure.relaxedStructure
                    ? 'success'
                    : ''}`}>
          <CardHeader className="m-0 p-0 border-bottom-0">
            <div className="row no-gutters align-items-center">
              <div className="col col-auto text-dark mr-auto pr-3 pl-3 pt-2 pb-2" style={{fontSize:16, fontWeight:700, lineHeight:1.3}}>
                {
                  structure.relaxedStructure
                    ? <Link className="text-dark" to={`/projects/${project._id}/structures/${structure._id}`}>{getFormula(structure.name)}</Link>
                    : <span>{getFormula(structure.name)}</span>
                }
              </div>
              <div className="col col-auto pr-3 pl-3 pt-2 pb-2">
                {
                  structure.generated
                    ? <span className="badge badge-light">Generated by Qcats</span>
                    : null
                }
              </div>

              <div className="col col-auto border-left">
                <Dropdown isOpen={this.state.dropdownOptions} toggle={this.toggleOptions} className="bg-none p-0">
                  <DropdownToggle className="bg-none btn-transparent text-gray-200 mt-0 pr-3 pl-3 pt-2 pb-2">
                    <span className="icon-settings icons font-1xl text-gray-700"></span>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={this.toggleRemoveFromProject}>Remove from {project.name}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              <div className="col col-auto border-left">

                <button onClick={this.toggle} className="btn btn-light btn-minimize text-gray-600 mt-0 pr-3 pl-3 pt-2 pb-2" data-toggle="collapse" aria-expanded="false">
                  <span data-toggle="tooltip" data-placement="top" title="Minimize/Maximize cardblock" className={`${ this.state.opened ? 'icon-arrow-up' : 'icon-arrow-down'} icons font-1xl text-gray-700`}></span>
                </button>


              </div>
            </div>
          </CardHeader>
          { this.state.opened ? <CardBody className="border-top p-0">
            <StructureDescription structure={structure.relaxedStructure
              ? structure.relaxedStructure
              : structure}/>
          </CardBody> : null }
          <CardFooter className="p-0 bg-white"> {
            structure.isOrdered
              ? <div className="">
                {
                  structure.relaxedStructure
                    ? <Row className="no-gutters">
                      {/* <Col className="card-actions col-auto bg-primary p-2 pb-1 text-white border-0 ">
                        <SuccessIcon size={24} className="mt-auto mb-auto" />
                      </Col> */}
                      <Col className="col-auto mr-auto mt-auto mb-auto mr-3 ml-3">
                        Relaxation succeeded ! Time CPU: { moment(structure.elapsed || '00:00:00', 'HH:mm:ss').add(structure.elapsed2 || '00:00:00', 'HH:mm:ss').format('HH:mm:ss') }<br/>
                      </Col>
                      <Col className="col-auto">
                        <Link className="btn btn-success" to={`/projects/${project._id}/structures/${structure._id}`}><PlayIcon className="mr-2"/> Go to the result page</Link>
                      </Col>
                    </Row>
                    : <div>
                      {
                          structure.relaxationStatus === 'off'
                            ? <Row className="no-gutters">
                              <Col className="mt-auto mb-auto mr-3 ml-3">This structure needs to be relaxed. </Col>
                              <Col className="col-auto ml-auto">
                                <button className="btn btn-info" disabled={this.state.isRelaxating} onClick={this.getRelaxedStructure}>
                                  <span className=" text-white"><PlayIcon className="mr-2"/> Launch the relaxation</span>
                                </button>
                              </Col>
                            </Row>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'initialised' || structure.relaxationStatus === 'initialisation'
                            ? <p className="alert alert-secondary mb-0">Relaxation launching.</p>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'pending'
                            ? <p className="alert alert-warning mb-0">Relaxation pending.</p>
                            : null
                      }
                      
                      {
                          structure.relaxationStatus === 'running'
                            ? <Row className="no-gutters">
                              <Col className="card-actions col-auto bg-info p-2 pb-1 text-white border-0 text-center">
                                {structure.relaxationTry === 1 ?
                                  <span>{Math.round(structure.relaxationStep / 2)}%</span> :
                                  <span>{Math.round(structure.relaxationStep / 2) + 50}%</span>
                                }
                              </Col>
                              <Col className="p-2 ">
                                <Row>
                                  <Col className="col-auto mr-auto"><small className="text-muted">Relaxation in progress.</small></Col>
                                  <Col className="col-auto">{ moment(structure.elapsed || '00:00:00', 'HH:mm:ss').add(structure.elapsed2 || '00:00:00', 'HH:mm:ss').format('HH:mm:ss') }</Col>
                                </Row>
                                <Progress color="info" className="progress-xs"
                                  animated value={structure.relaxationTry === 1 ? structure.relaxationStep / 2 : structure.relaxationStep / 2} />
                              </Col>
                            </Row>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'failed'
                            ? <Row className="p-0 ml-0">
                              {/*<Col className="card-actions col-auto bg-danger p-2 pb-1 text-white border-0 ">
                                <FailedIcon size={24} />
                              </Col>*/}
                              <Col className="mt-auto mb-auto mr-auto">
                                Relaxation failed. <a href="#/why">Why ? </a>
                              </Col>
                              <Col className="col-auto"><button disabled={this.state.isTryaAgaining} className="btn btn-danger h-100" onClick={this.tryAgain}>Try again ! <span className="icon-reload ml-2" /></button></Col>

                            </Row>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'retrying'
                            ? <p className="alert alert-warning mb-0">Trying again...</p>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'finishing'
                            ? <p className="alert alert-info mb-0">Analyzing results...</p>
                            : null
                      }

                      {
                          structure.relaxationStatus === 'broken'
                            ? <p className="alert alert-danger mb-0">There is a problem with the calcul.</p>
                            : null
                      }
                    </div>
                }

              </div> :
              <Row className="p-0 ml-0">
                <Col className="mt-auto mb-auto mr-auto">Disordered structure !</Col>
                <Col className="col-auto"><a href="#Disordered" onClick={this.toggleTutorialOdered} className="h-100 btn btn-warning">Please follow this tutorial</a></Col>
              </Row>
          }
          </CardFooter>

          <Modal isOpen={this.state.modalRemoveFromProject} toggle={this.toggleRemoveFromProject}>
            <ModalHeader>
              Are you sure you want to remove {structure.name} from {project.name} ?
            </ModalHeader>
            <ModalFooter>
              <Button type="submit" color="danger" onClick={this.removeStructure}>Remove</Button>{' '}
              <Button color="secondary" onClick={this.toggleRemoveFromProject}>Cancel</Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalTutorialOrdered} toggle={this.toggleTutorialOdered} className="modal-lg">
            <ModalHeader>

            </ModalHeader>
            <ModalBody>
              <img className="mw-100" src="/images/Tuto_desordre.png"/>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary" onClick={this.toggleTutorialOdered}>I've got it</Button>
            </ModalFooter>
          </Modal>
        </Card>
    )
  }
}

export default StructureItem



// WEBPACK FOOTER //
// ./src/containers/structures/item.js